<div class="device-dialog">
    <div class="mat-h1">
      {{text | devicePipeGlobal}}
    </div>
    <mat-dialog-content class="content" >
        <div class="device-data">
            <div class="mat-caption label">Issue date</div>
            <div>{{ issueDate | date:"dd MMM, yyyy"}}</div>
        </div>

        <div class="device-data" *ngIf="revoked">
            <div class="mat-caption label">Revoked on</div>
            <div>{{revokeDate  | date:"dd MMM, yyyy"}}</div>
            <div>{{revokeNote}}</div>
        </div>

        <div class="device-data" *ngIf="this.issuerData">
            <div class="mat-caption label">Issuer name</div>
            <div>{{this.issuerData.given.join(' ')}} {{this.issuerData.family ? this.issuerData.family : ''}}</div>
        </div>

        <div class="device-data">
            <div class="mat-caption label">Notes</div>
            <div>{{this.issuesNote}}</div>
        </div>
  </mat-dialog-content> 
    <mat-dialog-actions align="end">
        <button mat-button color="primary" (click)="removeDevice()" mat-dialog-close *ngIf="!revoked && (role == 'Admin' || role == 'Front office staff' ||  role == 'Healthcare provider')">REMOVE DEVICE</button>
        <button mat-button color="primary"   (click)="close()">CLOSE</button>
     </mat-dialog-actions>
</div>